const isCityPlace = (place) => place?.result_type === 'city' || place?.resultType === 'city';

/**
 * Remove city-level Places from exchange typeaheads that only accept terminals.
 * @param {Array<object>} places - Places returned by Purchase.
 * @param {object} options - Filtering options.
 * @param {boolean} options.terminalPlacesOnly - Whether city-level Places must be excluded.
 * @returns {Array<object>} Places prepared for the exchange typeahead.
 */
export default function prepareHybridPlaces(places = [], { terminalPlacesOnly = false } = {}) {
  if (!Array.isArray(places)) return [];
  if (!terminalPlacesOnly) return places;
  return places.filter((place) => !isCityPlace(place));
}

export { isCityPlace };
